// %i(empty working_on_earlier mastered_earlier mastered working_on studied_earlier)
export const MASTERED_EARLIER = "mastered_earlier"
export const MASTERED = "mastered"
export const WORKING_ON = "working_on"
export const STUDIED_EARLIER = "studied_earlier"
export const EMPTY = "empty"
export const WORKING_ON_EARLIER = "working_on_earlier"
export const COPY_TO_ALL_STUDENTS = ""
